<div class="user-query-chat-sheet tw-w-full tw-relative tw-flex tw-flex-col tw-bg-gray-100 tw-rounded-t-3xl tw-overflow-hidden">
  <span class="tw-w-20 tw-h-0.75 tw-rounded-lg tw-absolute tw-top-1 tw-left-1/2 -tw-translate-x-1/2 tw-bg-gray-275"></span>
  <div class="tw-w-full tw-flex-none tw-flex tw-justify-between tw-items-center tw-px-4 tw-pb-4 tw-pt-5 tw-tracking-tight tw-bg-white">
    <div class="tw-flex tw-items-center tw-gap-2">
      <img src="https://cdn.cureskin.com/app/img/ai-star.svg" alt="">
      <h1 class="tw-text-300 tw-font-semibold" i18n="@@cureskinHealthAssistant">Cure AI Health Assistant</h1>
    </div>
    <button type="button" aria-label="Close" class="tw-h-auto tw-min-w-0 !tw-mx-0 tw-p-0 tw-bg-transparent tw-text-gray-500 tw-text-500 tw-font-bold" (click)="closePopup()">&#10005;</button>
  </div>
  <div class="tw-w-full tw-flex tw-flex-col tw-flex-1 tw-min-h-0 tw-bg-gray-100 tw-px-1 tw-relative">
    @if (initialLoading()) {
      <ng-container [ngTemplateOutlet]="loadingSpinner"></ng-container>
    } @else {
      <div #scrollContainer class="tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-py-3 tw-px-3"
        (scroll)="onScroll()">
        <div #scrollContent class="tw-w-full">
        @if (loadingOldMessages()) {
          <ng-container [ngTemplateOutlet]="loadingSpinner"></ng-container>
        }
        @for (bubble of chatBubbles(); track bubble.id) {
          <div class="chat-bubble tw-w-full tw-flex tw-text-300"
            [class.tw-justify-end]="bubble.isUser"
            [class.tw-text-gray-800]="bubble.isUser"
            [class.tw-justify-start]="!bubble.isUser"
            [class.tw-text-gray-700]="!bubble.isUser">
            @if (bubble.isUser) {
              <div class="tw-bg-teal-300 tw-p-3 tw-rounded-t-xl tw-rounded-bl-xl tw-w-fit tw-mb-4 tw-max-w-chat-bubble-user tw-break-words" [innerHTML]="bubble.html"></div>
            } @else {
              <div class="tw-w-fit tw-max-w-chat-bubble tw-text-wrap tw-overflow-clip tw-mb-4 tw-flex tw-items-start tw-gap-2">
                <img src="/assets/icons/ai_ball_star.svg" class="tw-w-10" alt="" />
                <div class="tw-flex tw-flex-col tw-gap-2">
                  <div class="tw-bg-white tw-border-gray-200 tw-p-3 tw-rounded-b-xl tw-rounded-tr-xl" [innerHTML]="bubble.html"></div>
                  @if (bubble.inputs.length) {
                    <div class="tw-w-full tw-flex tw-flex-col tw-gap-2 tw-justify-start tw-items-start tw-pr-2 tw-mb-4">
                      @for (input of bubble.inputs; track input.text) {
                        <span class="tw-bg-white tw-border tw-border-teal-500 tw-rounded-xl tw-py-2 tw-px-4 tw-shadow-z1 tw-text-teal-600" role="button" (click)="handleInputClick(input)">
                          {{ input.text }}
                        </span>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (showThinking()) {
          <div class="tw-w-full tw-max-w-chat-bubble tw-mt-2 tw-flex tw-items-start tw-gap-2 tw-mb-10">
            <img src="/assets/icons/ai_ball_star_faded.svg" class="tw-w-10" alt="" />
            <div class="tw-w-full tw-flex tw-flex-col">
              <span class="tw-mb-3 tw-text-200 tw-text-gray-500" i18n="@@thinking">Thinking...</span>
              <div class="tw-flex tw-flex-col tw-w-full tw-mt-1">
                <div class="thinking-bar thinking-bar-1 tw-h-3 tw-rounded-full tw-bg-gradient-white-to-transparent"></div>
                <div class="thinking-bar thinking-bar-2 tw-h-3 tw-rounded-full tw-bg-gradient-white-to-transparent"></div>
                <div class="thinking-bar thinking-bar-3 tw-h-3 tw-rounded-full tw-bg-gradient-white-to-transparent"></div>
              </div>
            </div>
          </div>
        }
        @if (showExtraQuestions()) {
          <div class="tw-w-full tw-pt-10">
            <h2 class="tw-text-400 tw-mb-2 gradient-text" i18n="@@peopleAlsoAsk">People also ask...</h2>
            <div class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-overflow-x-auto hide-scrollbar tw-pb-2 tw-scroll">
              @for (question of extraQuestions(); track question.id) {
                <div class="tw-w-fit tw-text-nowrap tw-text-gray-700 tw-bg-white tw-flex tw-justify-start tw-gap-2 tw-py-3 tw-pl-2 tw-pr-7 tw-rounded-t-xl tw-rounded-br-xl" role="button" (click)="askExtraQuestion(question)">
                  <img src="https://cdn.cureskin.com/app/img/ai-star-gray.svg" class="tw-w-3" alt="">
                  {{ questionLabel(question) }}
                </div>
              }
            </div>
          </div>
        }
        </div>
      </div>
      @if (showInputBar()) {
        <div class="user-query-chat-composer tw-flex-none tw-w-full tw-bg-gray-100 tw-pt-1">
          <div class="tw-w-full tw-px-4">
            <div class="tw-w-full tw-flex tw-items-center tw-border tw-border-gray-200 tw-shadow-z9 tw-rounded-3 tw-bg-white">
              <textarea #msgInput class="user-query-chat-textarea tw-bg-white tw-py-3 tw-pl-3 tw-pr-2 tw-rounded-2xl tw-w-full tw-border-none"
                [disabled]="inputDisabled()"
                [class.tw-text-teal-500]="isVoiceListening()"
                (input)="onDraftChange(msgInput.value)"
                (keydown.enter)="onEnterPressed($event)"
                rows="1"
                name="message"
                i18n-placeholder="@@askAnything"
                placeholder="Ask Anything..."></textarea>
              <div #msgInputMirror class="user-query-chat-textarea-mirror" aria-hidden="true"></div>
              @if (isVoiceMicVisible()) {
                <voice-mic-input class="tw-mr-3 tw-mt-2"
                  [showTooltip]="showVoiceTooltip()"
                  (transcript)="onVoiceTranscript($event)"
                  (stateChange)="onVoiceStateChange($event)"
                  (tooltipShown)="dismissVoiceTooltip()"></voice-mic-input>
              }
              <button type="button" aria-label="Send"
                class="tw-self-center tw-h-auto tw-min-w-0 !tw-ml-0 !tw-mr-3 tw-w-fit tw-p-1.5 tw-rounded-full"
                [disabled]="inputDisabled()"
                [class.tw-bg-gray-300]="!hasDraft()"
                [class.tw-bg-teal-600]="hasDraft()"
                (click)="onSendClicked()">
                <img src="/assets/chat-send.svg" class="tw-w-6" alt="" />
              </button>
            </div>
          </div>
        </div>
      }
    }
  </div>
</div>

<ng-template #loadingSpinner>
  <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-py-2">
    <div class="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-2 tw-border-t-teal-500"></div>
  </div>
</ng-template>
